<div class="main-banner">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container-fluid">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-12">
                        <div class="banner-content text-center">
                            <h1>🌍 Ensemble pour la santé, l’éducation et le sport en Afrique</h1>
                            <p>
                                Bienvenue chez <strong>ASESA</strong> (<em>Aide pour la santé, l’éducation et le sport en Afrique</em>).
                                Nous agissons aux côtés des communautés à la base, en particulier dans les zones rurales les plus défavorisées,
                                pour améliorer durablement la santé, renforcer l’éducation, promouvoir l’hygiène/assainissement et soutenir les activités sportives.
                                Avec votre soutien, nous construisons des solutions utiles, inclusives et durables.
                            </p>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-12">
                        <div id="bannerCarousel" class="carousel slide banner-image" data-bs-ride="carousel">
                            <div class="carousel-inner rounded">
                                <div
                                    class="carousel-item"
                                    [class.active]="true"
                                >
                                    <!-- Images du carousel : à créer/ajouter plus tard -->
                                    <img src="assets/img/banner/banner.png" class="d-block w-100" alt="Image ASESA">
                                </div>
                            </div>

                            <!-- Contrôles -->
                            <button class="carousel-control-prev" type="button" data-bs-target="#bannerCarousel" data-bs-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            </button>
                            <button class="carousel-control-next" type="button" data-bs-target="#bannerCarousel" data-bs-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="fun-facts-area pt-100 pb-70">
    <app-funfacts></app-funfacts>
</section>

<section id="about">
    <section class="about-area pb-100">
        <app-about [isOnHome]="true"></app-about>
    </section>
    <!--section class="testimonials-area ptb-100">
        <app-testimonials></app-testimonials>
    </section-->
</section>

<section id="team" class="team-area pt-100 pb-70">
    <app-team [isOnHome]="true"></app-team>
</section>

<section id="kontakt" class="contact-area ptb-100">
    <app-contact [isOnHome]="true"></app-contact>
</section>
